export const FILTER_LABEL_CLASSNAME =
  "!text-base font-medium normal-case tracking-normal text-[var(--app-muted-text)]";
export const FILTER_OPTION_CLASSNAME = "!text-sm";

// A filter row announces its selection through weight, not through darker ink. The summary
// sits beside a muted label, so painting it --app-text made the value the heaviest element
// on the panel and read as an alert rather than a choice.
export const FILTER_VALUE_SELECTED_CLASSNAME = "font-semibold text-[var(--app-text-secondary)]";
export const FILTER_VALUE_IDLE_CLASSNAME = "text-[var(--app-muted-text)]";
